import React from 'react';
import { Box, Heading, Icon } from '@hover/blueprint';
import { IconProp } from '@hover/icons';
import { ScreenReaderText } from '../../../common';

interface Props {
  id: number;
  img: React.ReactNode;
  icon: IconProp;
  body: string;
  activeSlide: number;
}

const DesktopSlide: React.FC<Props> = ({
  id,
  img,
  icon,
  activeSlide,
  body,
  ...rest
}) => (
  <Box
    d="flex !important"
    alignItems="center"
    justifyContent="space-between"
    className="svg-back"
    role="group"
    aria-labelledby="active-element"
    {...rest}
  >
    <ScreenReaderText
      content={`slide ${activeSlide} of 2`}
      id="active-element"
    />
    <Box className="mobile-image-container" maxW="378px" maxH="530px">
      {img}
    </Box>
    <Box ml={1000} flex={1} alignItems="flex-start">
      <Box
        bg="green.500"
        alignItems="center"
        justifyContent="center"
        w="56px"
        h="56px"
        borderRadius="50%"
        mr={800}
      >
        <Icon icon={icon} size="large" color="neutral.0" />
      </Box>
      <Heading maxW={700} size={500} isLight as="p">
        {body}
      </Heading>
    </Box>
  </Box>
);

export default DesktopSlide;
